import { render, staticRenderFns } from "./WorkflowDetailPage.vue?vue&type=template&id=4cf0a1c4&"
import script from "./WorkflowDetailPage.vue?vue&type=script&lang=ts&"
export * from "./WorkflowDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports